import React, { useContext, useEffect } from "react";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AuthContext } from "context";
import Link from "@mui/material/Link";
import SidenavCollapse from "./SidenavCollapse";
import { NavLink } from "react-router-dom";
import Divider from "@mui/material/Divider";

function SubMenuScadenziario(props) {
	const authContext = useContext(AuthContext);
	const [isHovered, setIsHovered] = React.useState(false);
	const [submenuOpen, setSubmenuOpen] = React.useState(false);

	// Funzione per verificare se ci sono le autorizzazioni per le route
	const hasAnyAuth = (routeAuths) => {
		if (!routeAuths || routeAuths.length === 0) return true;
		return routeAuths.some((auth) => authContext.hasAuth(auth));
	};

	// Filtra le route basate sulle autorizzazioni per Scadenziario
	const filteredScadenziarioRoutes = props?.routes.filter((route) => {
		if (route.type === "Scadenziario") return hasAnyAuth(route.auths);
	});

	const renderRoutesType = (routes) => {
		return routes.map(({ type, name, icon, title, noCollapse, key, href, route, showInSidebar }) => {
			let returnValue;

			if (showInSidebar) {
				returnValue = href ? (
					<Link href={href} key={key} target="_blank" rel="noreferrer" sx={{ textDecoration: "none" }}>
						<SidenavCollapse
							name={name}
							icon={icon}
							active={key === props?.collapseName.split("/")[0]}
							noCollapse={noCollapse}
						/>
					</Link>
				) : (
					<NavLink key={key} to={route}>
						<SidenavCollapse name={name} icon={icon} active={key === props?.collapseName.split("/")[0]} />
					</NavLink>
				);
			}
			return returnValue;
		});
	};

	function handleMouseEnter() {
		setIsHovered(true);
	}

	function handleMouseLeave() {
		setIsHovered(false);
	}

	function handleSubmenuOpen() {
		setSubmenuOpen((prevState) => !prevState);
	}

	// Se non ci sono route per Scadenziario, non mostrare il menu
	if (filteredScadenziarioRoutes.length === 0) {
		return null;
	}

	return (
		<>
			<Box>
				{/* Menu principale Scadenziario */}
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					style={{
						cursor: "pointer",
						transition: "all 0.3s ease-in-out",
					}}
					onMouseEnter={() => handleMouseEnter()}
					onMouseLeave={() => handleMouseLeave()}
					onClick={() => handleSubmenuOpen()}
				>
					<MDTypography
						color={"white"}
						variant="body2"
						fontWeight="medium"
						style={{
							fontSize: isHovered ? "1.1rem" : "1rem",
							transition: "all 0.2s ease-in",
						}}
					>
						Scadenziario
					</MDTypography>
					<KeyboardArrowDownIcon color={"white"} style={{ marginLeft: "5px" }} fontSize={"medium"} />
				</Box>

				{submenuOpen && (
					<Box sx={{}}>
						{/* Routes di Scadenziario */}
						{filteredScadenziarioRoutes.length > 0 && (
							<Box sx={{}}>{renderRoutesType(filteredScadenziarioRoutes)}</Box>
						)}
					</Box>
				)}
			</Box>
			<Divider light={true}></Divider>
		</>
	);
}

export default SubMenuScadenziario;
